<div class="deviations-over-time-container">
  <div class="deviations-header">
    <div class="deviations-title">
      <h4>{{ 'reportsOverTime' | translate }}</h4>
      <p class="mobile-dashboard-description">
        {{ 'dashboardReportsOverTimeDescription' | translate }}
      </p>
    </div>
    <div class="deviations-controls">
      <app-ui-select
        [label]="'departmentSelector' | translate"
        [control]="vesselControl"
        [options]="vesselOptions"
        [isMultiple]="true"
        [selectAll]="true"
        [compactOnMobile]="true"
        class="control-field department-control"
        panelClass="dashboard-department-select-panel"
      ></app-ui-select>
      <app-ui-select
        [label]="'reportType' | translate"
        [control]="deviationControl"
        [options]="allDeviationOptions"
        [isMultiple]="true"
        [compactOnMobile]="true"
        emptyTriggerLabel="allReportTypes"
        [selectAll]="true"
        class="control-field report-type-control"
        panelClass="dashboard-report-type-select-panel"
      ></app-ui-select>
      <app-dashboard-time-period-select
        [periodControl]="timePeriodControl"
        [customRangeControl]="customRangeControl"
        [periodOptions]="timePeriodOptions"
      ></app-dashboard-time-period-select>
    </div>
  </div>

  <div *appLoader="isLoading">
    @if (hasData) {
      <!-- Trend indicator temporarily commented out - may be needed in the future -->
      <!-- <app-trend-indicator
        [trend]="trend"
        [trendText]="trendText"
        [periodLabel]="timePeriodLabel"
        [hasInsufficientData]="hasInsufficientData"
      ></app-trend-indicator> -->

      <div class="chart-container">
        <canvas id="reportsChart"></canvas>
      </div>

      @if (isMobileView() && selectedChartDataPoint) {
        <div class="chart-view-action">
          <app-ui-button
            color="primary"
            [text]="'viewReports' | translate"
            (click)="viewSelectedReports()"
          ></app-ui-button>
        </div>
      }

      <div class="chart-legend">
        <div class="legend-item">
          <span class="legend-dot legend-total"></span>
          <span>{{ 'totalReports' | translate }}: {{ totalDeviationsCount }}</span>
        </div>
        @if (!areAllDeviationsSelected) {
          @for (item of selectedDeviationCounts; track item.typeName) {
            <div class="legend-item">
              <span class="legend-dot" [style.background-color]="item.color"></span>
              <span>{{ item.typeName }}: {{ item.count }}</span>
            </div>
          }
        }
      </div>
    } @else {
      <div class="no-data-message">
        <p>{{ 'noDataFoundForSelectedFilters' | translate }}</p>
      </div>
    }
  </div>
</div>
